<template lang="pug">
    transition(appear v-bind="$attrs"  @before-enter="$emit('enter')" @before-leave="$emit('leave')")
        slot
</template>
<script>
export default {
    name: 'TransitionIf',
}
</script>
